import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { File } from '../../objects/file';
import { ListItem } from '../../objects/listItem';
import { UserPermissions } from '../../objects/permissions';
import {SharedDataService} from "../../services/shared-data.service";
import {DialogCanvasComponent} from "../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-listing-item',
  templateUrl: './listing-item.component.html',
})

export class ListingItemComponent implements OnInit {

  @Input() listItem: ListItem;
  @Input() operationsAllowed: UserPermissions;
  @Input() activeItemCounter: number; //used in right click menu
  @Input() singleRow: boolean;

  @Output() hidecontext = new EventEmitter<object>();
  @Output() dblclick = new EventEmitter<object>();
  @Output() contextmenu = new EventEmitter<object>();
  @Output() click = new EventEmitter<object>();
  @Output() download = new EventEmitter<void>();
  @Output() info = new EventEmitter<void>();
  @Output() zero = new EventEmitter<void>();
  @Output() zip = new EventEmitter<void>();
  @Output() unzip = new EventEmitter<void>();
  @Output() rename = new EventEmitter<void>();
  @Output() copy = new EventEmitter<void>();
  @Output() cut = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() restore = new EventEmitter<void>();
  @Output() copyInBuffer = new EventEmitter<void>();
  @Output() filemenu = new EventEmitter<void>();

  public handleMouseOut(event: MouseEvent) {
    event.stopPropagation()
    this.hidecontext.emit({ event, file: this.listItem })
  }

  public handleFileMenuClick(event: MouseEvent) {
    event?.stopImmediatePropagation()
    this.filemenu.emit()
  }

  public handleDbClick(event: MouseEvent) {
    this.showPurchases(this.listItem);
    return;
    event.stopPropagation()
    if (this.listItem.isNotAccessible) {
      this.sharedDataService.pushNotification({ text: `This ${this.listItem.isFile ? 'file' : 'directory'} is not accessible`, type: 'info' })
      return;
    }
    this.dblclick.emit(this.listItem)
  }

  public handleContextMenu(event: MouseEvent) {
return; //lazy to maintain. disabled for now
    event.stopPropagation();
    event.preventDefault();
    if (!this.listItem.isNotAccessible && !this.listItem.isStorage) {
      this.contextmenu.emit({ event, file: this.listItem })
    }
  }

  public handleRestore() {
    this.restore.emit()
  }
  public handleCopyInBuffer() {
    this.copyInBuffer.emit()
  }
  public handleReportDownload() {
    this.download.emit()
  }
  public profileInfo() {
    this.info.emit()
  }
  public handleZeroPoints() {
    this.zero.emit()
  }
  public handleZip() {
    this.zip.emit()
  }
  public handleUnzip() {
    this.unzip.emit()
  }
  public handleRename() {
    this.rename.emit()
  }
  public handleCopy() {
    this.copy.emit()
  }

  public handleCut() {
    this.cut.emit()
  }
  public handleDelete() {
    this.delete.emit()
  }
  public handleTrainerBooking() {
    this.click.emit()
  }

  constructor(public application: AppComponent,
              public dialog: MatDialog,
              private sharedDataService: SharedDataService) { }

  ngOnInit() {
  }

  public showReferrals(listItem:ListItem) {
    let payload = {item: listItem};
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //height: this.application.layoutMatches['isHandsetDefaultLayout'] ? '70%' : '50%',
      height: 'auto',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      data: {
        application: this.application,
        state: 'user-referrals-popup',
        payload: payload
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
  }
  public showPurchases(listItem:ListItem, mode = '') {
    console.log('listItem',listItem)
    let payload = {item: listItem, 'mode': mode};
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //height: this.application.layoutMatches['isHandsetDefaultLayout'] ? '70%' : '50%',
      height: 'auto',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      data: {
        application: this.application,
        state: 'user-purchases-popup',
        payload: payload
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
  }
  public trainerSetup(listItem:ListItem) {
    let payload = {item: listItem}; //
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: 'auto',
      //minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      data: {
        application: this.application,
        state: 'trainer-setup-popup',
        payload: payload
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        console.log('confirmed.',confirmed,payload);
        if(confirmed && payload['newProfilePayload']) {
          listItem['itemFullData']['payload'] = payload['newProfilePayload'];
        }
      })
  }

}
